import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import {
  TGetModerationComplainMicrofrontendResponse,
  fetchGetModerationComplainMicrofrontend,
} from '../../repositories/moderation-complain-frontend/v1';

type Parameters = {
  httpApi: IHttpApi;
  logger: ILogger;
};

export const getModerationComplainMicrofrontend = async ({
  httpApi,
  logger,
}: Parameters): Promise<IMicrofrontendManifest | null> => {
  try {
    const { statusCode, response } =
      await fetchGetModerationComplainMicrofrontend<TGetModerationComplainMicrofrontendResponse>({
        httpApi,
      });

    if (statusCode === 200) {
      return response.manifest;
    }
  } catch (error) {
    logger.error(error, { description: 'Api /v1/get-moderation-complain-microfrontend/ не отвечает' });
  }

  return null;
};
